export interface ToolScore {
  score: number;
  timestamp: number;
}

const KEY_PREFIX = 'tool-score-';

export function saveToolScore(toolId: string, score: number): void {
  try {
    const data: ToolScore = { score: Math.round(score), timestamp: Date.now() };
    localStorage.setItem(`${KEY_PREFIX}${toolId}`, JSON.stringify(data));
  } catch {
    // Ignore storage errors
  }
}

export function getToolScore(toolId: string): ToolScore | null {
  try {
    const raw = localStorage.getItem(`${KEY_PREFIX}${toolId}`);
    if (!raw) return null;
    return JSON.parse(raw) as ToolScore;
  } catch {
    return null;
  }
}

export function getAllToolScores(toolIds: string[]): Record<string, ToolScore | null> {
  const result: Record<string, ToolScore | null> = {};
  for (const id of toolIds) {
    result[id] = getToolScore(id);
  }
  return result;
}
